"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataHandler = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var MetadataHandler = /** @class */ (function () {
    function MetadataHandler() {
    }
    MetadataHandler.hasMetadata = function (metadataKey, target) {
        return !!target[metadataKey];
    };
    MetadataHandler.getDepsMetadata = function (metadataKey, target) {
        return target[metadataKey];
    };
    MetadataHandler.setDepsMetadata = function (metadataKey, metadata, target) {
        target[metadataKey] = metadata;
    };
    MetadataHandler.getMethodMetadata = function (metadataKey, target) {
        return target[metadataKey];
    };
    MetadataHandler.setMethodMetadata = function (metadataKey, metadata, target) {
        target[metadataKey] = metadata;
    };
    return MetadataHandler;
}());
exports.MetadataHandler = MetadataHandler;
//# sourceMappingURL=metadata-handler.js.map